// Stage6.jsx
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./stage6.css";
import puzzleImage from "./images/puzzle.png";
import Swal from "sweetalert2";
import { fetchReport, updateReport } from "../../scoreservice";
import JigsawPuzzle from "./JigsawPuzzle";
// import { ReactComponent as DoorSvg } from "./images/Door.svg";
import DoorSVG from './images/Door.svg';
import finalVideo from "./images/video.mp4";






const timeToSeconds = (timeStr = "00:00") => {
  const [m = 0, s = 0] = timeStr.split(":").map(Number);
  return m * 60 + s;
};

export default function Stage6({ updateHeader }) {
  useEffect(() => {
    updateHeader({ backButtonRedirect: "/stage6" });
  }, []);

  const STAGE = 6;
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [initialTime, setInitialTime] = useState("00:00");
  const [ready, setReady] = useState(false);
  const [totalScore, setTotalScore] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [showPuzzle, setShowPuzzle] = useState(false);
  const [puzzleCompleted, setPuzzleCompleted] = useState(false);
  const [doorEnabled, setDoorEnabled] = useState(false);
  const [svgLoaded, setSvgLoaded] = useState(false);
  const [doorState, setDoorState] = useState('closed'); // closed, open, door
  const svgRef = useRef(null);
  const doorEnabledRef = useRef(false);
  const [playVideo, setPlayVideo] = useState(false);
  const videoRef = useRef(null);


  useEffect(() => {
    doorEnabledRef.current = doorEnabled;
  }, [doorEnabled]);


  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  

  useEffect(() => {
    const loadStageData = async () => {
      if (!userData?.userId) return;

      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,
        });

        if (res.status === "success") {
          setTotalScore(res.total_score || 0);
          setInitialTime(res.time || "00:00");

           if ((res.points || 0) > 0) {
            navigate("/thankyou");
            return;
          }
        } else {
          setInitialTime("00:00");
        }
      } catch (err) {
        console.error("Fetch stage6 failed", err);
        setInitialTime("00:00");
      } finally {
        setReady(true);
      }
    };

    loadStageData();
  }, [userData, navigate]);

  useEffect(() => {
    if (!initialTime) return;

    const baseSeconds = timeToSeconds(initialTime);
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      const totalSeconds = baseSeconds + elapsedSeconds;

      setMinutes(Math.floor(totalSeconds / 60));
      setSeconds(totalSeconds % 60);
    }, 1000);

    return () => clearInterval(interval);
  }, [initialTime]);

  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPuzzle(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleCompletion = async () => {
    if (completed) return;

    setCompleted(true);
    const newScore = totalScore + 1;
    setTotalScore(newScore);

    try {
      await updateReport({
        sessionId: userData.sessionId,
        userId: userData.userId,
        organizationId: userData.organizationId,
        reportId: userData.reportId,
        stage: STAGE,
        score: newScore,
        time: formattedTime,
        roles: userData.roles,
        token: userData.token || ""
      });

      Swal.fire({
        imageUrl: "/img/success.gif",
        showConfirmButton: false,
        timer: 3000,
        background: "transparent",
      }).then(() => {
        setDoorEnabled(true); // unlock AFTER popup
      });
    } catch (err) {
      console.error("Stage6 submit error", err);
    }
  };

  const handlePuzzleComplete = () => {
    setPuzzleCompleted(true);

  };

  const handlePuzzleClose = () => {
    setShowPuzzle(false);

    if (puzzleCompleted && !completed) {
      handleCompletion();


    }
  };

  const handleImageClick = (imageId) => {
    if (!doorEnabledRef.current) return;

    switch (imageId) {
      case 'Door':
        setDoorState('open');
        showImage('Open');
        hideImage('Closed');

        // ⏱️ wait 1 second then play video
        setTimeout(() => {
          setPlayVideo(true);
        }, 1000);
        break;
    }
  };


  const showImage = (imageId) => {
    const image = document.getElementById(imageId);
    if (image) {
      image.style.display = 'block';
      image.style.cursor = 'pointer';
    }
  };

  const hideImage = (imageId) => {
    const image = document.getElementById(imageId);
    if (image) {
      image.style.display = 'none';
    }
  };

  useEffect(() => {
    if (!svgRef.current) return;

    const loadAndProcessSvg = async () => {
      try {
        console.log('Loading Door SVG');
        const response = await fetch(DoorSVG);
        const svgText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, 'image/svg+xml');
        const svg = doc.querySelector('svg');

        if (!svg) return;

        // Set up SVG
        svg.classList.add('door-svg');
        if (!svg.getAttribute('viewBox')) {
          svg.setAttribute('viewBox', '0 0 1920 900');
        }

        // Make images clickable
        const images = svg.querySelectorAll('image');
        images.forEach(image => {
          if ( image.id === 'Door' || image.id === 'Open') {
            image.style.cursor = 'pointer';
            image.addEventListener('click', () => handleImageClick(image.id));

            // Set initial state - show Closed, hide others
            if (image.id === 'Door') {
              image.style.display = 'block';
            } else {
              image.style.display = 'none';
            }
          }
        });

        // Create container and append SVG
        const container = document.createElement('div');
        container.className = 'svg-content door-container';
        container.appendChild(svg);
        svgRef.current.innerHTML = '';
        svgRef.current.appendChild(container);

        // Mark SVG as loaded
        setSvgLoaded(true);

        return () => {
          // Clean up event listeners
          images.forEach(image => {
            if (image.id === 'Closed' || image.id === 'Door' || image.id === 'Open') {
              image.removeEventListener('click', () => handleImageClick(image.id));
            }
          });
        };
      } catch (error) {
        console.error('Error loading Door SVG:', error);
      }
    };

    loadAndProcessSvg();
  }, []);

  return (
    <div className="stage6-bg">

    <div className="screen6">
  <div className="gamehead-wrapper">
    <h4 className="gameHead-6">
      It’s the final countdown. Enter the warehouse and seize the day!
    </h4>
  </div>

  <div className="top-bar-6">
    <div className="timer-back-6">Time: {formattedTime}</div>
    <div className="score-6">Points: {totalScore}</div>
  </div>
</div>


      <div className="door-game-container">
        {/* <div className="door-info">
          <h2>Interactive Door</h2>
          <p>Current state: <strong>{doorState}</strong></p>
          <p>Click on the door to cycle through states: Closed → Door → Open → Closed</p>
        </div> */}
        <div className="svg-container1" ref={svgRef}></div>
      </div>

      {showPuzzle && (
        <div className="puzzle-modal-overlay">
          <div className="puzzle-modal">
            <JigsawPuzzle
              image={puzzleImage}
              difficulty="expert"
              onComplete={handlePuzzleComplete}
              onClose={handlePuzzleClose}
              aspectRatio="2:3" // Vertical rectangle (width:height)
            />
          </div>
        </div>
      )}


      {playVideo && (
        <div className="video-overlay">
          <video
  ref={videoRef}
  src={"https://2023-extramileplay-public.s3.ap-south-1.amazonaws.com/national-heist-new-video.mp4"}
  autoPlay
  playsInline
  onEnded={() => navigate("/thankyou")}
  className="final-video"
/>


        </div>
      )}

    </div>
  );
}